import { formatearPrecio } from "../../../../utils/utils";
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';


export const obtenerInfoCotizaciones = (cotizaciones) => {
  
        if (!cotizaciones || cotizaciones.length === 0) {
          console.log("cotizaciones es null");
            return{
            cantidad: cotizaciones.length,
            promedio: 0,
            //nuevos
            // Devolvemos valores por defecto para evitar errores en el componente
            textoPromedio: 'Promedio: N/A',
            textoMinimo: 'Mínimo: N/A',
            textoMaximo: 'Máximo: N/A',
            textoListaTutores: '',
          }
        }
    
        const cotizacionesValidas = cotizaciones.filter(cot => 
          cot.cotizacion && typeof cot.cotizacion === 'number' && cot.cotizacion > 0
        );
    
        if (cotizacionesValidas.length === 0) {
          return {
            cantidad: cotizaciones.length,
            estimado: "Pendiente de precio",
            rango: null,
            promedio: 0,
            textoMinimo: 'Mínimo: N/A',
            textoMaximo: 'Máximo: N/A',
            textoListaTutores: '',
          };
        }

    
        const precios = cotizacionesValidas.map(cot => cot.cotizacion);
        const precioMin = Math.min(...precios);
        const precioMax = Math.max(...precios);
        const precioPromedio = precios.reduce((sum, precio) => sum + precio, 0) / precios.length;
        const precioPromedioRedondeado = Math.ceil(precioPromedio / 1000) * 1000;


        //nuevas cosas
        const cotizacionMin = cotizacionesValidas.find(cot => cot.cotizacion === precioMin);
        const cotizacionMax = cotizacionesValidas.find(cot => cot.cotizacion === precioMax);
        const tutorMinNombre = cotizacionMin?.nombretutor || 'Desconocido';
        const tutorMaxNombre = cotizacionMax?.nombretutor || 'Desconocido';
        const listaTutores = cotizacionesValidas.map(cot => cot.nombretutor || 'Desconocido');
        //resumen
        const textoPromedio = `Promedio: ${formatearPrecio(precioPromedioRedondeado)}`;
        const textoMinimo = `Mínimo: ${formatearPrecio(precioMin)} (${tutorMinNombre})`;
        const textoMaximo = `Máximo: ${formatearPrecio(precioMax)} (${tutorMaxNombre})`;
        const textoResumen = `${cotizacionesValidas.length} cotizaciones`;

        let estimadoTexto;
        let rangoTexto;
    
        if (cotizacionesValidas.length === 1) {
          estimadoTexto = formatearPrecio(precios[0]);
          rangoTexto = `${ formatearPrecio(precios[0])}`;
        } else {
          if (precioMin === precioMax) {
            estimadoTexto = formatearPrecio(precioMin);
            rangoTexto = `${formatearPrecio(precioMin)}`;
          } else {
            estimadoTexto = formatearPrecio(precioPromedio);
            rangoTexto = `${formatearPrecio(precioMin)} - ${formatearPrecio(precioMax)}`;
          }
        }
    
        return{
          cantidad: cotizaciones.length,
          cantidadValidas: cotizacionesValidas.length,
          estimado: estimadoTexto,
          rango: rangoTexto,
          promedio: precioPromedioRedondeado,
          //NUEVOS
          textoResumen,
          textoPromedio,
          textoMinimo,
          textoMaximo,
          participantes: cotizacionesValidas.map(cot => ({
            nombre: cot.nombretutor || 'Desconocido',
            precio: cot.cotizacion
          })),
        }

}
